import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

// The trial CTA destination is content-managed (`trial_cta_url`) and may be a
// site path or a full URL — route client-side when it's ours, hard-navigate
// otherwise.
function CtaLink({ to, className, onClick, children }) {
  if (to.startsWith('/'))
    return (
      <Link to={to} className={className} onClick={onClick}>
        {children}
      </Link>
    )
  return (
    <a href={to} className={className} onClick={onClick}>
      {children}
    </a>
  )
}

CtaLink.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired
}

CtaLink.defaultProps = {
  className: '',
  onClick: undefined
}

export default CtaLink
